/* Drawer Cart JS */
/**
 * Get reference to the mini-cart, mini-cart__trigger and overlay DOM
 * elements.
 */
const miniCart = document.querySelector(".mini-cart");
const miniCartTrigger = document.querySelector(".site-header__cart");
const overlay = document.querySelector(".overlay");
const atb = document.querySelector(".button--add-to-bag");
const miniCartClose = document.querySelector(".cart__close");
const miniCartFooter = document.querySelector("#shopify-section-footer");
  
/**
 * When the user clicks the mini-cart__trigger element add classes to the
 * overlay and mini-cart elements to show them.
 */
document.querySelectorAll(".open-window").forEach(function(link) {
  link.addEventListener("click", function(event) {
    event.preventDefault(); // Prevent default link behavior
    window.open(this.href, "_blank", "width=800,height=600,resizable=yes,scrollbars=yes");
  });
});

document.body.addEventListener("click", async (e) => {
  const miniCartTrigger2 = e.target.closest(".site-header__cart"); // Cart icon
  const atb2 = e.target.closest(".button--add-to-bag"); // Add to Bag button

  if (miniCartTrigger2) {
    await openMiniCart();
  }

  if (atb2) {
    setTimeout(() => {
      document.querySelector(".site-header__cart")?.click(); // Simulate click after delay
    }, 2000); // Adjust delay as needed (500ms = 0.5s)
  }
});

async function openMiniCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cartData = await response.json();
    await renderCart(cartData);
    overlay.classList.add("overlay--show");
    miniCart.classList.add("mini-cart--show");
    
    // Prevent body scroll and horizontal scrollbar
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    miniCartFooter.style.display = "none";
  } catch (err) {
    console.error("Cart update failed:", err);
  }
}

/**
 * Handle cart open on Add to Cart Click Button
 */

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (e) {
    const addToBagBtn = e.target.closest(".custom_add_to_bag");

    if (addToBagBtn) {
      e.preventDefault();

      const productId = addToBagBtn.getAttribute("data-product-id");
      const variantId = addToBagBtn.getAttribute("data-variant-id");

      if (!variantId) {
        console.error("No variant selected for this product.");
        return;
      }

      // Prepare the request payload
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      // Send request to Shopify API
      try {
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartData = await response.json();
        // Open the mini cart after adding an item
        setTimeout(() => {
          document.querySelector(".site-header__cart")?.click();
          document.dispatchEvent(new Event('cart:updated'));
        }, 500);
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    }
  });
});
 
// document.addEventListener("DOMContentLoaded", function () {
//   document.body.addEventListener("click", function (e) {
//     const addToCartContainer = e.target.closest(".hidden_add_to_cart");

//     if (addToCartContainer) {
//       e.preventDefault();

//       // Find the button inside the container
//       const button = addToCartContainer.querySelector("button[data-variant-id]");

//       if (!button) {
//         console.error("No button found inside .hidden_add_to_cart");
//         return;
//       }

//       const variantId = button.getAttribute("data-variant-id");

//       if (!variantId) {
//         console.error("No variant selected for this product.");
//         return;
//       }

//       // Prepare the request payload
//       const formData = new FormData();
//       formData.append("id", variantId);
//       formData.append("quantity", 1);

//       // Send request to Shopify API
//       fetch(window.Shopify.routes.root + "cart/add.js", {
//         method: "POST",
//         body: formData,
//       })
//         .then((response) => response.json())
//         .then((cartData) => {
//           console.log("Product added to cart:", cartData);

//           // Open the mini cart after adding an item
//           setTimeout(() => {
//             document.querySelector(".site-header__cart")?.click();
//           }, 500);
//         })
//         .catch((error) => console.error("Error adding to cart:", error));
//     }
//   });
// });


document.body.addEventListener("click", async (e) => {
  const atc = e.target.closest(".product-form__btn");

  if (atc) {
    e.preventDefault();
    const form = atc.closest("form");
    const quantityInput = form.querySelector(".quantity-selector__field");
    const productId = form.getAttribute("data-productid");

    if (!form) {
      console.error("Add to Cart form not found.");
      return;
    }

    const formData = new FormData(form);
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const productVariantId = formData.get('id');
    if(formData.get('purchase_type') == 'onetime') {
   //   formData.set('selling_plan', '');
formData.delete('selling_plan');

    }
    //selling_plan_bar
    if(formData.get('selling_plan_bar') != null)
    {
      formData.set('selling_plan', formData.get('selling_plan_bar')); 
      formData.set('purchase_type','autodeliver')
    }
    try {
      // Fetch the current cart
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cartData = await cartResponse.json();

      // Check if the product already exists in the cart
   /*   const existingItem = cartData.items.find(
        (item) => item.id == productVariantId
      );
      */
      
      const  existingItem = false;

      if (existingItem) {
        // Update the existing item's quantity
        const updateData = {
          updates: {
            [existingItem.key]: existingItem.quantity + quantity, // Increase quantity
          },
        };

        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });

      } else {
        // Add as a new product if it doesn't exist in cart
        formData.append("quantity", quantity);
        formData.append("product_id", productId);

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formData).toString(),
        });
      }

      // Refresh cart after update
      setTimeout(() => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            renderCart(cartData);
            overlay.classList.add("overlay--show");
            miniCart.classList.add("mini-cart--show");
            miniCartFooter.style.display = "none";
            document.dispatchEvent(new Event('cart:updated'));
          })
          .catch((err) => console.error("Cart update failed:", err));
      }, 800);

    } catch (err) {
      console.error("Cart update failed:", err);
    }
  }
});


/**
 * When the user clicks the overlay element remove classes from the mini-cart
 * and overlay to hide them again.
 */

document.body.addEventListener("click", async (e) => {
  if (e.target.closest(".overlay")) {
    const overlay2 = document.querySelector(".overlay");
    const miniCart2 = document.querySelector(".mini-cart");

    overlay2?.classList.remove("overlay--show");
    miniCart2?.classList.remove("mini-cart--show");
    
    // Restore body and documentElement overflow
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
});

/**
 * When the user clicks the close mini cart button remove classes from the mini-cart.
 */

miniCartClose.addEventListener("click", async () => {
  overlay.classList.remove("overlay--show");
  miniCart.classList.remove("mini-cart--show");
  
  // Restore body and documentElement overflow
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
});

/**
 * Initialize subscription cache and load cart
 */
// Load subscription cache on page load
loadSubscriptionCache();

/**
 * Sends a GET request to the '/{locale}/cart.js' route of the Shopify Ajax
 * API, returns the response as JSON and then passes the data to the
 * renderCart function, which outputs the content.
 */
fetch(window.Shopify.routes.root + "cart.js")
  .then((response) => response.json())
  .then((data) => {
    // Loop through items and attach them to the DOM
    renderCart(data);
  })
  .catch((err) => console.log(err));

let rebuyCarouselHandler = null;

function handleRebuyCarousels(retryCount = 0) {
  const maxRetries = 10;
  const retryDelay = 200;
  
  if (window.Rebuy && window.Rebuy.widgets && window.Rebuy.widgets.length > 0) {
    let widgetsProcessed = 0;
    
    window.Rebuy.widgets.forEach(widget => {
      if (widget.View && widget.View.carousel) {
        // Check if carousel element exists and has proper dimensions
        const carouselElement = widget.View.carousel.element;
        if (carouselElement && carouselElement.offsetHeight > 0) {
          widget.View.carousel.options.adaptiveHeight = true;
          widget.View.carousel.options.resize = true;
          widget.View.carousel.options.watchCSS = true;
          widget.View.carousel.resize();
          widgetsProcessed++;
        }
      }
    });
    
    // If no widgets were processed and we have retries left, try again
    if (widgetsProcessed === 0 && retryCount < maxRetries) {
      setTimeout(() => handleRebuyCarousels(retryCount + 1), retryDelay);
    }
  } else if (retryCount < maxRetries) {
    // Rebuy not ready yet, retry
    setTimeout(() => handleRebuyCarousels(retryCount + 1), retryDelay);
  }
}

// Remove existing listener if it exists and add new one
if (rebuyCarouselHandler) {
  document.removeEventListener('rebuy.init', rebuyCarouselHandler);
}

rebuyCarouselHandler = function() {
  // Use multiple timeouts to catch widgets at different loading stages
  setTimeout(() => handleRebuyCarousels(), 100);
  setTimeout(() => handleRebuyCarousels(), 300);
  setTimeout(() => handleRebuyCarousels(), 500);
};

document.addEventListener('rebuy.init', rebuyCarouselHandler);

/**
 * Determine if an item should be subscribed based on explicit subscription intent
 * rather than just the presence of selling_plan_allocation
 */
function determineSubscriptionState(item) {
  // First check cached subscription states - this should override everything
  const cachedState = getSubscriptionCache(item.key);
  if (cachedState !== null) {
    return cachedState;
  }
  
  // Check for explicit subscription properties from PLP/PDP
  if (item.properties) {
    // Check for 'Subscribe & Save' property set to 'true' (from PLP subscription button)
    if (item.properties['Subscribe & Save'] === 'true') {
      return true;
    }
    
    // Check for 'purchase_type' set to 'autodeliver' (from PDP subscription button)
    if (item.properties['purchase_type'] === 'autodeliver') {
      return true;
    }
    
    // Check for delivery interval property (indicates subscription intent)
    if (item.properties['Delivery'] && item.properties['purchase_type'] !== 'onetime') {
      return true;
    }
  }
  
  // Check for selling plan allocation (PDP subscription indicator)
  if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
    const sellingPlan = item.selling_plan_allocation.selling_plan;
    
    // Check if the selling plan name indicates subscription (contains delivery interval)
    if (sellingPlan.name && (
      sellingPlan.name.toLowerCase().includes('delivery') ||
      sellingPlan.name.toLowerCase().includes('days') ||
      sellingPlan.name.toLowerCase().includes('weeks') ||
      sellingPlan.name.toLowerCase().includes('months') ||
      sellingPlan.name.toLowerCase().includes('subscribe') ||
      sellingPlan.name.toLowerCase().includes('recurring')
    )) {
      return true;
    }
    
    // Additional check: if selling plan has a discount, it's likely a subscription
    if (item.selling_plan_allocation.per_delivery_price < item.price) {
      return true;
    }
  }
  
  // Handle edge case: Item shows discount but missing selling_plan_allocation
  // This can happen when items are merged or data is inconsistent
  // Check if the current price suggests it's discounted (approximately 80% of original)
  if (item.price && item.original_price && item.price < item.original_price) {
    const discountRatio = item.price / item.original_price;
    // If discount is approximately 20% (price is 80% of original), it's likely a subscription
    if (discountRatio >= 0.75 && discountRatio <= 0.85) {
      return true;
    }
  }
  
  return false;
}

/* Get cached subscription state for an item*/

function getSubscriptionCache(itemKey) {
  if (!window.subscriptionCache) {
    window.subscriptionCache = {};
  }
  // Check if the key exists in cache - return the actual value (including false)
  if (itemKey in window.subscriptionCache) {
    return window.subscriptionCache[itemKey];
  }
  return null;
}

/**
 * Set cached subscription state for an item
 */
function setSubscriptionCache(itemKey, isSubscribed) {
  if (!window.subscriptionCache) {
    window.subscriptionCache = {};
  }
  window.subscriptionCache[itemKey] = isSubscribed;
  
  // Also store in localStorage for persistence across page refreshes
  try {
    const cache = JSON.parse(localStorage.getItem('cart_subscription_cache') || '{}');
    cache[itemKey] = isSubscribed;
    localStorage.setItem('cart_subscription_cache', JSON.stringify(cache));
  } catch (e) {
    console.warn('Failed to save subscription cache to localStorage:', e);
  }
}

/**
 * Load subscription cache from localStorage
 */
function loadSubscriptionCache() {
  try {
    const cache = JSON.parse(localStorage.getItem('cart_subscription_cache') || '{}');
    window.subscriptionCache = cache;
  } catch (e) {
    console.warn('Failed to load subscription cache from localStorage:', e);
    window.subscriptionCache = {};
  }
}

/**
 * Add event listeners for subscription functionality
 */
function addSubscriptionEventListeners() {
  // Prevent multiple event listeners
  if (window.subscriptionEventListenersAdded) return;
  window.subscriptionEventListenersAdded = true;
  
  // Use event delegation for subscription checkboxes and dropdowns
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('subscribe-save-checkbox')) {
      handleSubscribeToggle(event.target);
    } else if (event.target.classList.contains('subscribe-dropdown')) {
      handleIntervalChange(event.target);
    }
  });
}

/**
 * Handle subscription toggle checkbox
 */
async function handleSubscribeToggle(checkbox) {
  const itemKey = checkbox.dataset.lineKey;
  const isChecked = checkbox.checked;
  
  // Update cache immediately
  setSubscriptionCache(itemKey, isChecked);
  
  // Update UI
  const dropdownWrap = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-dropdown-wrap');
  const textSpan = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-text');
  
  if (isChecked) {
    dropdownWrap.style.display = 'block';
    textSpan.innerHTML = 'Subscribed';
    
    // Get the selected interval and update the cart with selling plan
    const dropdown = dropdownWrap.querySelector('.subscribe-dropdown');
    if (dropdown && dropdown.value) {
      await handleIntervalChange(dropdown);
    }
  } else {
    dropdownWrap.style.display = 'none';
    textSpan.innerHTML = 'Subscribe & Save <span class="subscribe-save-discount">30%</span>';
    
    // Remove selling plan from cart item
    try {
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: ''
        })
      });
      
      if (updateResponse.ok) {
        // Trigger cart update
        if (window.refreshCart) {
          window.refreshCart();
        }
      }
    } catch (error) {
      console.error('Error removing selling plan:', error);
    }
  }
}

/**
 * Handle interval change dropdown
 */
async function handleIntervalChange(select) {
  const itemKey = select.dataset.lineKey;
  const selectedValue = select.value;
  const cartItem = select.closest('.mini-cart__item');
  
  if (!cartItem) return;
  
  let sellingPlanId = null;
  
  // Check if the selected value is already a selling plan ID (numeric)
  if (/^\d+$/.test(selectedValue)) {
    // Value is already a selling plan ID, use it directly
    sellingPlanId = parseInt(selectedValue);
  } else {
    // Value is interval text, check if we have the selling plan ID in data attribute
    const selectedOption = select.querySelector(`option[value="${selectedValue}"]`);
    if (selectedOption && selectedOption.dataset.sellingPlanId) {
      sellingPlanId = parseInt(selectedOption.dataset.sellingPlanId);
    } else {
      // Fallback: find the selling plan ID by matching interval text
      try {
        const productHandle = cartItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
        if (!productHandle) return;
        
        // Fetch product data to get selling plan ID
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) return;
        
        const productData = await response.json();
        
        // Find the selling plan that matches the new interval
        if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
          for (const group of productData.selling_plan_groups) {
            if (group.selling_plans) {
              for (const plan of group.selling_plans) {
                if (plan.name && plan.name.toLowerCase().includes(selectedValue.toLowerCase().replace(' days', ''))) {
                  sellingPlanId = plan.id;
                  break;
                }
              }
              if (sellingPlanId) break;
            }
          }
        }
      } catch (error) {
        console.error('Error finding selling plan for interval:', error);
        return;
      }
    }
  }
  
  if (sellingPlanId) {
    // Update the cart item with the new selling plan
    try {
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: sellingPlanId
        })
      });
      
      if (updateResponse.ok) {
        // Trigger cart update
        if (window.refreshCart) {
          window.refreshCart();
        }
      }
    } catch (error) {
      console.error('Error updating cart with selling plan:', error);
    }
  }
}

/**
 * Clear subscription cache for removed items
 */
function cleanupSubscriptionCache(currentItems) {
  if (!window.subscriptionCache) return;
  
  const currentKeys = currentItems.map(item => item.key);
  const cacheKeys = Object.keys(window.subscriptionCache);
  
  // Remove cache entries for items no longer in cart
  cacheKeys.forEach(key => {
    if (!currentKeys.includes(key)) {
      delete window.subscriptionCache[key];
    }
  });
  
  // Update localStorage
  try {
    localStorage.setItem('cart_subscription_cache', JSON.stringify(window.subscriptionCache));
  } catch (e) {
    console.warn('Failed to update subscription cache in localStorage:', e);
  }
}

/**
 * Outputs cart items and content in the DOM.
 */
async function renderCart(data) {
  // Prevent concurrent renderCart calls - this fixes duplicate items issue
  if (window.renderCartLock) {
    console.log('[renderCart] Blocked concurrent render call');
    return;
  }
  window.renderCartLock = true;
  
  try {
    // Load subscription cache from localStorage
    loadSubscriptionCache();
    
    // Add CSS for eligibility
    addEligibilityCSS();
    
    // Add event listeners for subscription functionality
    addSubscriptionEventListeners();
    
    // Add missing properties (GWP, Final Sale) to cart items
    const cartDataWithProperties = await addMissingProperties(data);
    
    // Clean up subscription cache for removed items
    cleanupSubscriptionCache(cartDataWithProperties.items);

    // Get DOM element where the cart items will be attached
    const miniCartItems = document.querySelector(".mini-cart__items");
    const subtotalPrice = document.querySelector(".subtotal-price");
    const totalCartItems = document.querySelector(".total__cart__items");
    const miniCartSummary = document.querySelector(".mini-cart__summary");
    const checkoutButton = document.querySelector(".cart__checkout");
    const productSlider = document.querySelector(".product-slider");
    const miniCartSlider = document.querySelector("#mini-cart-carousel");
    const shippingCalculator = document.querySelector(".shipping-calculator-wrap");
    
    const miniCartSliderHeading = document.querySelector(
      ".product-slider-heading"
    );
    const klarnaPlacement = document.querySelector(".cart_klarna");
    const cartCount = document.querySelector(".nav__cart-count span");
    let cartItemsIds = cartDataWithProperties.items.map((e) => e.product_id);
    // Clear HTML in the mini cart items
    if (miniCartItems) miniCartItems.innerHTML = "";
    let subtotal = 0;
    let totalItems = 0;

  // Loop through cart items and attach them to the mini-cart__items element
  if (cartDataWithProperties.items.length > 0) {
    

    for (const item of cartDataWithProperties.items) {
      

      const actualPrice = item?.selling_plan_allocation?.per_delivery_price ? item?.selling_plan_allocation?.per_delivery_price : item.original_price;
      const originalPrice = actualPrice * item.quantity;

      const size = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "size"
      )?.value;
      const color = item.options_with_values.find(
        (opt) =>
          opt.name.toLowerCase() === "color" ||
          opt.name.toLowerCase() === "colour"
      )?.value;
      const width = item.options_with_values.find(
        (opt) => opt.name.toLowerCase() === "width"
      )?.value;
      let sizeAndColor = [size, color, width].filter(Boolean).join(" | ");

      // Check if item is GWP (Gift With Purchase)
      const isGwpItem = item.properties && (
        item.properties["Note"] && item.properties["Note"].includes("GWP") || 
        item.properties["note"] && item.properties["note"].includes("GWP") || 
        item.properties.Note && item.properties.Note.includes("GWP") || 
        item.properties["_Note"] && item.properties["_Note"].includes("GWP") ||
        item.properties["_gwp_nc"] === "1" || 
        item.properties["_gift_for_purchase"] === "true"
      );

      // Check if this is a bundle item
      const isBundleItem = item.properties && item.properties._bundle_type === 'custom_set';

      // Only add to subtotal if NOT a GWP item and NOT a bundle item (bundle handled separately)
      if (!isGwpItem && !isBundleItem) {
        subtotal += originalPrice;
        totalItems += item.quantity;
      } else if (!isBundleItem) {
        // GWP items still count towards item count
        totalItems += item.quantity;
      }
      // Bundle items: subtotal and totalItems already handled in bundle block above
      const disableMinQuantity = (item.quantity  == 1) ? 'disabled' : '';
      let productTitle = item.product_title;
      //productTitle = productTitle.replace(/Lip Oasisᵀᴹ/g, 'lip oasis<sup>TM</sup>');
      let sellingPlanHTML = '';
      if(item.selling_plan_allocation){
          // sellingPlanHTML = `<div class="opacity-60">${item.selling_plan_allocation.selling_plan.name}</div>`;
      }
      let saleTagHtml = '';
      if (item.properties && (item.properties["Note"] === "Final Sale" || item.properties["_Note"] === "Final Sale")) {
         saleTagHtml =`<span class="sale-cart-tag item-property badge sale-badge" style="visibility: hidden;">Final Sale</span>`;
      } else {
      }
      let gwpTagHtml = '';
      if (isGwpItem) {
        gwpTagHtml +=`<span class="sale-cart-tag item-property badge gwp-badge" style="font-size: 11px; margin-left: 0; display: inline-block; vertical-align: middle; padding: 4px 10px 2px;">Discount applied at next step</span>`;
      }
      
      // price display on whether item is GWP
      let priceDisplayHtml = '';
      let priceDataAttr = '';
      let trueOriginalPrice = null;
      if (isGwpItem) {
        // For GWP items, show strikethrough original price and "FREE"
        priceDisplayHtml = `
          <span class="original-price" style="text-decoration: line-through; color: #999;">$${((originalPrice) / 100).toFixed(2)}</span>
          <span class="free-price" style="color: #000000;">FREE</span>
        `;
        priceDataAttr = '';
      } else if (item.selling_plan_allocation) {
        // For subscription items, we need the TRUE original variant price
        // Shopify's item.original_price is already the selling plan price
        let trueOriginalUnitPrice = null;
        
        // Try to get true original price from product data cache
        if (window.productVariantPriceCache && item.handle) {
          const cacheKey = `${item.handle}_${item.variant_id}`;
          trueOriginalUnitPrice = window.productVariantPriceCache[cacheKey];
        }
        
        if (trueOriginalUnitPrice) {
          // Use the true original price from cache
          const discountedTotal = (item.selling_plan_allocation.per_delivery_price * item.quantity) / 100;
          const originalTotal = trueOriginalUnitPrice * item.quantity;
          priceDisplayHtml = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
          priceDataAttr = ` data-original-price="$${trueOriginalUnitPrice.toFixed(2)}"`;
        } else {
          // Fallback: use current logic while we fetch the true price
          const discountedTotal = (item.selling_plan_allocation.per_delivery_price * item.quantity) / 100;
          const originalTotal = (item.original_price * item.quantity) / 100;
          priceDisplayHtml = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
          priceDataAttr = ` data-original-price="$${(item.original_price / 100).toFixed(2)}"`;
          
          // Fetch the true original price for future use
          if (item.handle) {
            fetch(`/products/${item.handle}.js`)
              .then(res => res.json())
              .then(productData => {
                const variant = productData.variants.find(v => v.id == item.variant_id);
                if (variant) {
                  if (!window.productVariantPriceCache) window.productVariantPriceCache = {};
                  const cacheKey = `${item.handle}_${item.variant_id}`;
                  window.productVariantPriceCache[cacheKey] = variant.price / 100;
                }
              })
              .catch(error => {
                // Silently fail, we have fallback pricing
              });
          }
        }
      } else {
        // For regular items, show normal price
        const total = (item.price * item.quantity) / 100;
        priceDisplayHtml = `<span class="discounted-price">$${total.toFixed(2)}</span>`;
        priceDataAttr = '';
      }
      // Only inject Subscribe & Save UI for eligible items (async check)
      let subscribeSaveHtml = '';
      const eligible = await hasSellingPlan(item);
      // Build dynamic dropdown options if eligible
      let dropdownHtml = ''; 
      if (eligible) {
        const intervalOptions = (productDataCache[item.handle] && productDataCache[item.handle].intervalOptions) || [];
        
        // Debug: Log interval options for troubleshooting
        if (item.properties && item.properties['Delivery']) {
          intervalOptions.forEach(opt => {
            const optionInterval = opt.label.replace(/\s*Delivery\s*/i, '').trim();
          });
        }
        
        dropdownHtml = intervalOptions.length
          ? `<select class="subscribe-dropdown" data-line-key="${item.key}" style="width: 100%;">${
              intervalOptions.map(opt => {
                let isSelected = false;
                
                // Check for PDP items (with selling_plan_allocation)
                if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                  // For PDP items, we need to match by selling plan ID
                  // Store the selling plan ID in a data attribute for easy access
                  const sellingPlanId = opt.value;
                  isSelected = item.selling_plan_allocation.selling_plan.id == sellingPlanId;
                  
                  // Extract interval text from label for display
                  const intervalText = opt.label.replace(/\s*Delivery\s*/i, '').trim();
                  
                  return `<option value="${sellingPlanId}" data-interval="${intervalText}"${isSelected ? ' selected' : ''}>${intervalText}</option>`;
                }
                // Check for PLP items (with properties) 
                else if (item.properties && item.properties['Delivery']) {
                  // Extract interval from option label and match with property
                  // Remove "Delivery" and "every" and normalize case to match PLP format
                  const optionInterval = opt.label
                    .replace(/\s*Delivery\s*/i, '')
                    .replace(/\s*every\s*/i, '')
                    .trim()
                    .replace(/days/i, 'Days'); // Normalize to "Days" with capital D
                  
                  isSelected = item.properties['Delivery'] === optionInterval;
                  
                  // For PLP items, use interval text as value and store selling plan ID in data attribute
                  const intervalText = opt.label.replace(/\s*Delivery\s*/i, '').trim();
                  
                  return `<option value="${intervalText}" data-selling-plan-id="${opt.value}"${isSelected ? ' selected' : ''}>${intervalText}</option>`;
                }
                
                // Default case: use interval text as value
                const intervalText = opt.label.replace(/\s*Delivery\s*/i, '').trim();
                return `<option value="${intervalText}" data-selling-plan-id="${opt.value}"${isSelected ? ' selected' : ''}>${intervalText}</option>`;
              }).join('')
            }</select>` 
          : '';
        // Determine if item should be checked based on explicit subscription intent
        const shouldBeSubscribed = determineSubscriptionState(item);
        
        subscribeSaveHtml = `
          <div class="subscribe-save-cart-ui">
            <label class="subscribe-save-label">
              <input type="checkbox" class="subscribe-save-checkbox" data-line-key="${item.key}" data-variant-id="${item.variant_id}:${item.key}"${shouldBeSubscribed ? ' checked' : ''}>
              <span class="subscribe-save-text">
                ${shouldBeSubscribed ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount">30%</span>'}
              </span>
            </label>
            <div class="subscribe-save-dropdown-wrap" style="${shouldBeSubscribed ? '' : 'display: none;'} margin-top: 5px;">
              ${dropdownHtml}
            </div>
          </div>
        `;
        
        // Note: Price display is already handled above for items with selling_plan_allocation
      } else {
        // console.log('NOT setting subscribeSaveHtml for', item.handle, '- keeping empty string');
      }
      
      const eligibilityAttribute = eligible ? 'data-subscription-eligible="true"' : 'data-subscription-eligible="false"';
      
      // Check if this is a bundle item
      const isBundle = item.properties && item.properties._bundle_type === 'custom_set';
      
      let itemHtml;
      
      if (isBundle) {
        // Custom bundle template
        const bundleImage = item.properties._bundle_image || item.featured_image.url;
        const bundleTitle = item.properties._bundle_title || 'Custom Bundle';
        const bundleSubtitle = item.properties._bundle_subtitle || 'Custom set';
        
        // Calculate actual bundle total from all variants
        let calculatedBundleTotal = 0;
        try {
          const bundleVariants = JSON.parse(item.properties._bundle_variants);
          calculatedBundleTotal = bundleVariants.reduce((sum, v) => sum + v.price, 0);
        } catch (e) {
          // Fallback to item price if parsing fails
          calculatedBundleTotal = item.final_line_price;
        }
        
        const bundleTotal = `$${(calculatedBundleTotal / 100).toFixed(2)}`;
        const bundleCount = item.properties._bundle_count || `${item.quantity} items`;
        const bundleProducts = item.properties._bundle_products || 'Bundle items';
        
        // Add bundle total to subtotal (not the single item price)
        subtotal += calculatedBundleTotal;
        totalItems += 1; // Bundle counts as 1 item in cart
        
        itemHtml = `
          <div class="mini-cart__item bundle-item" ${eligibilityAttribute} data-line-key="${item.key}">
            <div class="bundle-layout" style="display: flex; gap: 12px; align-items: flex-start;">
              <div class="bundle-image" style="flex-shrink: 0;">
                <img src="${bundleImage}" alt="Bundle" class="item__image" style="width: 80px; height: 80px; object-fit: cover;" />
              </div>
              <div class="bundle-details" style="flex-grow: 1;">
                <h3 class="product-title" style="margin: 0 0 4px 0; font-size: 14px; font-weight: 600;">${bundleTitle}</h3>
                <p class="bundle-subtitle">${bundleSubtitle}</p>
                <p class="product-price" style="margin: 0 0 8px 0; font-size: 16px; font-weight: 600;">${bundleTotal}</p>
                <p class="bundle-description">
                  <span class="bundle-count">${bundleCount}:</span>
                  <span class="bundle-products">${bundleProducts}</span>
                </p>
              </div>
              <div class="bundle-actions" style="flex-shrink: 0;">
                <button class="item__remove" data-line-key="${item.key}" style="background: none; border: none; cursor: pointer; padding: 4px;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" fill="transparent" stroke="currentColor" class="icon" style="width: 20px; height: 20px;">
                    <path d="M4 6h12" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.5 9v5M11.5 9v5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 6 6 17h8l.5-11" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 6V5c0-1 .75-2 2-2s2 1 2 2v1" stroke-width="1.25"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="error-message"></div>
          </div>
        `;
      } else {
        // Regular item template
        itemHtml = `
          <div class="mini-cart__item" ${eligibilityAttribute} data-line-key="${item.key}">
            <a href="${item.url}" class="item__image-link">
              <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" class="item__image" />
            </a>
            <div class="item__info">
              <h3 class="product-title"><a href="${item.url}">${productTitle}</a></h3>
            <div>
            <p class="product-price"${priceDataAttr}>
              ${priceDisplayHtml}
            ${saleTagHtml}
            ${gwpTagHtml}
            </p>
        </div>
     <p class="product-size"> ${sizeAndColor}
     </p>
      ${item.variant_id === 46936252416257 ? `<p class="gwp-line-item" style="font-size: 12px; text-transform: uppercase; margin-top: 10px;">Free with orders above: $100</p>` : ''}
      ${sellingPlanHTML}
      ${item.selling_plan_allocation ? `<input type='hidden' data-selling-plan value='${item.selling_plan_allocation.selling_plan.id}'>` : ''}
     <div class="price__and__quantity">
      <div class="item__actions">
           <div class="quantity-input">
              <button type="button" class="minus quantity-selector__action  ${disableMinQuantity}" ${disableMinQuantity}>-</button>
              <input type="hidden" class="item__line-key" value="${item.key}" />
              <input type="text" class="item__quantity" min="1" value="${
                item.quantity
              }" />
              <button type="button" class="plus">+</button>
           </div>
           <button class="item__remove" data-line-key="${
             item.key
           }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" fill="transparent" stroke="currentColor" class="icon"><path d="M4 6h12" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 9v5M11.5 9v5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 6 6 17h8l.5-11" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6V5c0-1 .75-2 2-2s2 1 2 2v1" stroke-width="1.25"/></svg>
           </button>
        </div>
        ${subscribeSaveHtml}
     </div>
    <div class="error-message"></div>
  </div>
  </div>
        `;
      }
      miniCartItems.innerHTML += itemHtml;
      
      // Bundle functionality removed - keeping products simple

      // Update values
      if (subtotalPrice)
        subtotalPrice.textContent = `$${(subtotal / 100).toFixed(2)}`;
      if (totalCartItems) {
        totalCartItems.textContent =
          totalItems > 1
            ? `SHOPPING CART (${totalItems} ITEMS)`
            : `SHOPPING CART (${totalItems} ITEM)`;
      }


      // Update Klarna `data-purchase-amount`
    if (klarnaPlacement) {
      klarnaPlacement.setAttribute("data-purchase-amount", subtotal);
    }

    // Update the cart count in the header
    if (cartCount) {
      cartCount.textContent = totalItems;
    }

      // Show mini-cart summary and checkout button
      [
        miniCartSummary,
        checkoutButton,
        productSlider,
        miniCartSlider,
        miniCartSliderHeading,
        shippingCalculator
      ].forEach((el) => {
        if (el) el.style.display = "block";
      });
    };
    // Set global cart data for subscribe-save-cart-ui.js
    window.cartData = cartDataWithProperties;
    // Dispatch event to inject Subscribe & Save UI
    document.dispatchEvent(new Event('subscribe-save-inject'));
    var slideItems = document.getElementsByClassName("product-cart-slider");
    for (var j = 0; j < slideItems.length; j++) {
      slideItems[j].classList.remove("disable");
    }
    for (var i = 0; i < cartItemsIds.length; i++) {
      var elementClass = "cart-product-recommend-slider-" + cartItemsIds[i];
      var element = document.getElementsByClassName(elementClass);

      if (element.length != 0) {
        element[0].classList.add("disable");
      }
    }
    const miniCartBottom = document.querySelector('.mini-cart-bottom');
    const cartItemsContent = document.querySelector('.cart-grid-items-wrap');
    if (miniCartBottom && cartItemsContent) {
        const height = miniCartBottom.offsetHeight + 10;
        cartItemsContent.style.paddingBottom = `${height}px`;
    }




  } else {
    miniCartItems.innerHTML =
      '<div class="mini-cart__empty"><img src="https://theoutset.com/cdn/shop/files/logo.svg?v=1676481590" alt="logo" /><p>You have no items in your cart</p><a href="/"><button class="mini-cart__empty__button">Continue Shopping</button></a></div>';
    if (subtotalPrice) subtotalPrice.textContent = "$0.00";
    if (totalCartItems) totalCartItems.textContent = `YOUR CART`;

     // Update Klarna `data-purchase-amount`
     if (klarnaPlacement) {
      klarnaPlacement.setAttribute("data-purchase-amount", "0");
    }

    // Reset cart count in the header
    if (cartCount) {
      cartCount.textContent = "0";
    }

    // Hide mini-cart summary and checkout button
    [
      miniCartSummary,
      checkoutButton,
      productSlider,
      miniCartSlider,
      miniCartSliderHeading,
      shippingCalculator
    ].forEach((el) => {
      if (el) el.style.display = "none";
    });
  }

    // Calculate subtotal for shipping calculator based on displayed prices (includes manual subscription discounts)
    function calculateDisplayedSubtotal() {
      let displayedSubtotal = 0;
      const cartItems = document.querySelectorAll('.mini-cart__item');
      
      cartItems.forEach(item => {
        // Check if item is GWP (Gift With Purchase) - exclude from shipping calculation
        const isGwpItem = item.querySelector('.gwp-badge') || 
                         item.querySelector('[class*="gwp"]') ||
                         item.textContent.includes('GWP') ||
                         item.textContent.includes('Discount applied at next step');
        
        if (!isGwpItem) {
          const priceElement = item.querySelector('.product-price');
          if (priceElement) {
            const priceSpan = priceElement.querySelector('.discounted-price');
            if (priceSpan) {
              const priceText = priceSpan.textContent.trim();
              const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
              if (priceMatch) {
                const amount = parseFloat(priceMatch[1].replace(',', ''));
                displayedSubtotal += amount;
              }
            }
          }
        }
      });
      
      return displayedSubtotal * 100; // Convert to cents for consistency with original subtotal
    }

    // Use displayed subtotal for shipping calculator after DOM is updated
    setTimeout(() => {
      const displayedSubtotal = calculateDisplayedSubtotal();
      
      document.querySelectorAll(".shipping-calculator").forEach((element) => {
        const goal = element.getAttribute('data-goal');
        let shipping_diff = `$${((goal - displayedSubtotal) / 100).toFixed(2)}`;
        let widthValue = goal === 0
        ? "100%"
        : `${(displayedSubtotal * 100) / goal}%`;

        const priceElement = document.querySelector('.free-shipping-progress__text [v-text="price"]');
        if (priceElement) {
          priceElement.textContent = shipping_diff;
        }
        
        document.querySelectorAll('.shipping-text').forEach(el => el.classList.add('hidden'));
        if(goal == 0) {
          document.querySelector('[data-id="beforeGoal"]')?.classList.remove('hidden');
        }
        else if(goal <= displayedSubtotal) {
          document.querySelector('[data-id="goalReached"]')?.classList.remove('hidden');
        }
        else {
          document.querySelector('[data-id="goalStarted"]')?.classList.remove('hidden');
        }
        const parent = document.querySelector('.shipping-text:not(.hidden)');
        if (parent) {
          parent.querySelector('.free-shipping-progress__bar').style.width = widthValue;
        }
      });
    }, 100);

    document.querySelectorAll(".cart-rebuy-slider").forEach((element) => {
      const goal = element.getAttribute('data-goal');
      if(goal <= subtotal) element.classList.remove("hidden");
      else element.classList.add("hidden");
    });
    document.querySelectorAll(".recommend-products-slider").forEach((element) => {
      element.classList.add("hidden");
      const goal = element.getAttribute('data-goal');
      if(goal > subtotal && subtotal > 0) element.classList.remove("hidden");
    
    });

    //
    if (window.Rebuy && typeof window.Rebuy.init === 'function') {
      window.Rebuy.init();
      // Also handle carousels directly after cart update
      setTimeout(() => handleRebuyCarousels(), 200);
    }

  } catch (error) {
    console.error('[renderCart] Error during render:', error);
  } finally {
    // Always release the lock, even if there was an error
    window.renderCartLock = false;
  }


  if (typeof handleQuantityInputs === "function") handleQuantityInputs();
  if (typeof handleRemoveItem === "function") handleRemoveItem();
  if (window.SubscribeSave && typeof window.SubscribeSave.updateCartSubtotal === 'function') {
    window.SubscribeSave.updateCartSubtotal();
  }
  
  // Bundle toggle functionality removed for simplicity
}

/**
 * Capture current subscription states from the UI and save to cache
 */
function captureSubscriptionStates() {
  const subscriptionStates = {};
  document.querySelectorAll('.subscribe-save-cart-ui').forEach(container => {
    const checkbox = container.querySelector('.subscribe-save-checkbox');
    const key = checkbox?.dataset.lineKey;
    if (!key) return;
    
    const isChecked = checkbox.checked || false;
    const interval = container.querySelector('.subscribe-dropdown')?.value || '45 Days';
    
    subscriptionStates[key] = {
      checked: isChecked,
      interval: interval
    };
    
    // Save to cache if user has interacted with this item
    if (checkbox.hasAttribute('data-user-interacted')) {
      setSubscriptionCache(key, isChecked);
    }
  });
  return subscriptionStates;
}

/**
 * Restore subscription states to the UI after cart re-render
 */
function restoreSubscriptionStates(subscriptionStates) {
  Object.entries(subscriptionStates).forEach(([key, state]) => {
    const container = document.querySelector(`.subscribe-save-checkbox[data-line-key="${key}"]`)?.closest('.subscribe-save-cart-ui');
    if (!container) return;

    const checkbox = container.querySelector('.subscribe-save-checkbox');
    const dropdownWrap = container.querySelector('.subscribe-save-dropdown-wrap');
    const dropdown = container.querySelector('.subscribe-dropdown');
    const textSpan = container.querySelector('.subscribe-save-text');
    const priceElement = container.closest('.mini-cart__item')?.querySelector('.product-price');

    // 1. Update the actual checkbox input
    checkbox.checked = state.checked;
    
    // 2. Force visual update for custom checkboxes
    if (state.checked) {
      checkbox.setAttribute('checked', 'checked');
    } else {
      checkbox.removeAttribute('checked');
    }

    // 3. Update text content
    if (textSpan) {
      textSpan.innerHTML = state.checked ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount">30%</span>';
    }

    // 4. Show/hide dropdown
    if (dropdownWrap) {
      dropdownWrap.style.display = state.checked ? 'block' : 'none';
    }

    // 5. Update dropdown value
    if (dropdown && state.interval) {
      dropdown.value = state.interval;
    }

    // 6. Update pricing display
    if (priceElement && window.SubscribeSave && window.SubscribeSave.updateItemPrice) {
      window.SubscribeSave.updateItemPrice(priceElement, state.checked);
    }

    // 7. Mark as user-interacted to prevent auto-reset
    checkbox.setAttribute('data-user-interacted', 'true');
    if (dropdown) {
      dropdown.setAttribute('data-user-interacted', 'true');
    }
  });

  // Update cart subtotal after restoring states
  if (window.SubscribeSave && window.SubscribeSave.updateCartSubtotal) {
    window.SubscribeSave.updateCartSubtotal();
  }
}

// Global function to update shipping calculator with current displayed prices
function updateShippingCalculator() {
  // Calculate subtotal based on displayed prices (includes manual subscription discounts)
  function calculateDisplayedSubtotal() {
    let displayedSubtotal = 0;
    const cartItems = document.querySelectorAll('.mini-cart__item');
    
    cartItems.forEach(item => {
      // Check if item is GWP (Gift With Purchase) - exclude from shipping calculation
      const isGwpItem = item.querySelector('.gwp-badge') || 
                       item.querySelector('[class*="gwp"]') ||
                       item.textContent.includes('GWP') ||
                       item.textContent.includes('Discount applied at next step');
      
      if (!isGwpItem) {
        const priceElement = item.querySelector('.product-price');
        if (priceElement) {
          const priceSpan = priceElement.querySelector('.discounted-price');
          if (priceSpan) {
            const priceText = priceSpan.textContent.trim();
            const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
            if (priceMatch) {
              const amount = parseFloat(priceMatch[1].replace(',', ''));
              displayedSubtotal += amount;
            }
          }
        }
      }
    });
    
    return displayedSubtotal * 100; // Convert to cents for consistency with original subtotal
  }

  const displayedSubtotal = calculateDisplayedSubtotal();
  
  document.querySelectorAll(".shipping-calculator").forEach((element) => {
    const goal = element.getAttribute('data-goal');
    let shipping_diff = `$${((goal - displayedSubtotal) / 100).toFixed(2)}`;
    let widthValue = goal === 0
    ? "100%"
    : `${(displayedSubtotal * 100) / goal}%`;

    const priceElement = document.querySelector('.free-shipping-progress__text [v-text="price"]');
    if (priceElement) {
      priceElement.textContent = shipping_diff;
    }
    
    document.querySelectorAll('.shipping-text').forEach(el => el.classList.add('hidden'));
    if(goal == 0) {
      document.querySelector('[data-id="beforeGoal"]')?.classList.remove('hidden');
    }
    else if(goal <= displayedSubtotal) {
      document.querySelector('[data-id="goalReached"]')?.classList.remove('hidden');
    }
    else {
      document.querySelector('[data-id="goalStarted"]')?.classList.remove('hidden');
    }
    const parent = document.querySelector('.shipping-text:not(.hidden)');
    if (parent) {
      parent.querySelector('.free-shipping-progress__bar').style.width = widthValue;
    }
  });
}

// Export to window so it can be used from other files
window.updateShippingCalculator = updateShippingCalculator;
window.getSubscriptionCache = getSubscriptionCache;
window.setSubscriptionCache = setSubscriptionCache;
window.loadSubscriptionCache = loadSubscriptionCache;


/**
 * Attaches event listeners to the quantity input buttons, and
 * updates the value of the quantity input field.
 */

function handleQuantityInputs() {
  // Get a refernce to any quantity inputs
  const qtyInputEls = document.querySelectorAll(".mini-cart .quantity-input");

  // If there are any then loop through them and attach event listeners
  if (qtyInputEls.length > 0) {
    qtyInputEls.forEach((input) => {
      let plusBtn = input.querySelector(".plus");
      let minusBtn = input.querySelector(".minus");
      let qtyInput = input.querySelector(".item__quantity");
      let lineKey = input.querySelector(".item__line-key").value;

      // Store previous valid quantity in a data attribute
      qtyInput.setAttribute("data-prev-value", qtyInput.value);

      // Increase the quantity input value
      plusBtn.addEventListener("click", () => {
        let newQty = parseInt(qtyInput.value) + 1;
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });

      // Decrease the quantity input value, making sure it doesn't go below 1
      minusBtn.addEventListener("click", () => {
        let newQty = Math.max(1, parseInt(qtyInput.value) - 1); // Prevent going below 1
        qtyInput.setAttribute("data-prev-value", qtyInput.value);
        updateItemQuantity(lineKey, newQty, qtyInput);
      });
    });
  }
}

/**
 * Sends a request to the Ajax API to update the quantity of the line item.
 */

function updateItemQuantity(lineKey, value, qtyInput) {
  const subscriptionStates = captureSubscriptionStates();

  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: parseInt(value),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data?.status === 422) {
        const miniCartItem = document.querySelector(
          `.mini-cart__item[data-line-key="${lineKey}"]`
        );
        let errorMsg = miniCartItem.querySelector(".error-message");

        errorMsg.textContent = data.message;

        qtyInput.value = qtyInput.getAttribute("data-prev-value");
        return;
      }

      document
        .querySelectorAll(".error-message")
        .forEach((msg) => msg.remove());

      renderCart(data).then(() => {
        // Restore subscription states after re-render
        restoreSubscriptionStates(subscriptionStates);
      });
    })
    .catch((err) => console.error("Cart update failed:", err));
}

/**
 * Sends a request to the Ajax api, updating the selected items quantity
 * to 0, which will remove it from the cart.
 */

function handleRemoveItem(lineKey, value) {
  const removeItemButton = document.querySelectorAll(".item__remove");

  removeItemButton.forEach((button) => {
    // Remove any existing event listeners to prevent duplicates
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Get the line item key from the buttons data attribute
    let lineKey = newButton.dataset.lineKey;

    newButton.addEventListener("click", () => {
      // Update the item quantity to 0 in the cart to remove it
      updateItemQuantity(lineKey, 0);
    });
  });
}

/**
 * Handle removing all cart items
 */
const removeAllButton = document.querySelector(".mini-cart__remove-all");
if (removeAllButton) {
  removeAllButton.addEventListener("click", () => {
    fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "post",
    })
      .then((response) => response.json())
      .then((data) => {
        renderCart(data);
      });
  });
}

/**
 * Event listener for mini-cart-open event triggered by Vue.js components
 * This ensures the cart is properly rendered with sale tags when items are added via quick-add-to-cart buttons
 */
document.body.addEventListener("mini-cart-open", async (event) => {
  
  // Capture current subscription states before re-rendering
  const subscriptionStates = captureSubscriptionStates();
  
  // If cart data is provided in the event detail, use it to render the cart
  if (event.detail && event.detail.items) {
    await renderCart(event.detail);
    // Restore subscription states after rendering
    restoreSubscriptionStates(subscriptionStates);
  } else {
    // Otherwise, fetch the current cart data and render it
    // Add a small delay to ensure cart data is fresh
    setTimeout(() => {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          renderCart(cartData).then(() => {
            // Restore subscription states after rendering
            restoreSubscriptionStates(subscriptionStates);
          });
        })
        .catch((err) => console.error("Cart update failed:", err));
    }, 100);
  }
  
  // Open the mini cart
  overlay.classList.add("overlay--show");
  miniCart.classList.add("mini-cart--show");
  document.body.style.overflow = 'hidden';
  miniCartFooter.style.display = "none";
});

/**
 * Check if a product should have GWP or Final Sale properties and add them if missing
 * This ensures that items added via Vue.js components get the same properties as items added via the product form
 */
function addMissingProperties(cartData) {
  
      if (!cartData || !cartData.items) {
      return cartData;
    }
  
  // Create a copy of the cart data to modify
  const modifiedCartData = JSON.parse(JSON.stringify(cartData));
  
  // Process each item to check for product tags
  const processItems = async () => {
    for (let item of modifiedCartData.items) {
      // Check if the item already has GWP or Final Sale properties
      const hasGwpProperty = item.properties && (
        item.properties["_gwp_nc"] === "1" || 
        item.properties["_gift_for_purchase"] === "true" ||
        item.properties["Note"] && item.properties["Note"].includes("GWP")
      );
      
      const hasFinalSaleProperty = item.properties && (
        item.properties["Note"] === "Final Sale" || 
        item.properties["_Note"] === "Final Sale"
      );
      
      if (!hasGwpProperty && !hasFinalSaleProperty) {
        // Initialize properties if they don't exist
        if (!item.properties) {
          item.properties = {};
        }
        
        try {
          // Fetch product data from Shopify to get the actual tags
          const productResponse = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`);
          const productData = await productResponse.json();
          
          // Check if product has GWP or Final Sale tags
          const productTags = productData.tags || [];
          const hasGwpTag = productTags.some(tag => 
            tag.toLowerCase().includes('gwp') || 
            tag.toLowerCase().includes('gift') || 
            tag.toLowerCase().includes('free')
          );
          const hasFinalSaleTag = productTags.some(tag => 
            tag.toLowerCase().includes('final sale') || 
            tag.toLowerCase().includes('final-sale') ||
            tag.toLowerCase().includes('flash sale') ||
            tag.toLowerCase().includes('flash-sale')
          );
          
          if (hasGwpTag) {
            // Set properties that Vue.js cart-item component expects
            item.properties["_gwp_nc"] = "1";
            item.properties["_gift_for_purchase"] = "true";
            item.properties["Note"] = "Discount applied at next step";
          } else if (hasFinalSaleTag) {
            item.properties["Note"] = "Final Sale";
          }
          
        } catch (error) {
        }
      }
    }
    
    return modifiedCartData;
  };
  
  // Return a promise that resolves with the processed cart data
  return processItems();
}

const productDataCache = {};

  // check if a product/variant has selling plans
  async function hasSellingPlan(item) {
    if (!item.handle) {
      return false;
    }
    if (productDataCache[item.handle]) {
      const productData = productDataCache[item.handle];
      // Cache interval options if not already cached
      if (!productData.intervalOptions) {
        const group = productData.selling_plan_groups && productData.selling_plan_groups[0];
        if (group) {
          productData.intervalOptions = group.selling_plans.map(plan => ({
            label: plan.name,
            value: plan.id
          }));
        } else {
          productData.intervalOptions = [];
        }
      }
      const eligible = productData.selling_plan_groups && productData.selling_plan_groups.length > 0;
      return eligible;
    }
    try {
      const productData = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`).then(res => res.json());
      // Cache interval options
      const group = productData.selling_plan_groups && productData.selling_plan_groups[0];
      if (group) {
        productData.intervalOptions = group.selling_plans.map(plan => ({
          label: plan.name,
          value: plan.id
        }));
      } else {
        productData.intervalOptions = [];
      }
      productDataCache[item.handle] = productData;
      const eligible = productData.selling_plan_groups && productData.selling_plan_groups.length > 0;
      return eligible;
    } catch (e) {
      return false;
    }
  }

  function addEligibilityCSS() {
    if (!document.getElementById('subscription-eligibility-css')) {
      const style = document.createElement('style');
      style.id = 'subscription-eligibility-css';
      style.textContent = `
        .mini-cart__item[data-subscription-eligible="false"] .subscribe-save-cart-ui {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

// Update fetch interceptors and event listeners to use async/await with renderCart
// Intercept cart API calls to ensure renderCart is called

document.addEventListener('DOMContentLoaded', function() {
  // Override fetch to intercept cart API calls
  const originalFetch = window.fetch;
  window.fetch = async function(url, options) {
    // Check if this is a cart-related API call
    if (url && (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js'))) {
      const response = await originalFetch.apply(this, arguments);
      // Clone the response so we can read it
      const clonedResponse = response.clone();
      try {
        const data = await clonedResponse.json();
        // If this is a cart update, trigger renderCart
        if (data && (data.items || data.item_count !== undefined)) {
          await renderCart(data);
        }
      } catch (err) {}
      return response;
    }
    return originalFetch.apply(this, arguments);
  };

  // Also watch for changes to the cart count in the header
  const cartCountElement = document.querySelector('.nav__cart-count span');
  if (cartCountElement) {
    const observer = new MutationObserver(async function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          try {
            const response = await fetch(window.Shopify.routes.root + "cart.js");
            const cartData = await response.json();
            await renderCart(cartData);
          } catch (err) {
            console.error("Cart update failed:", err);
          }
        }
      }
    });
    observer.observe(cartCountElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
});

// Global event listener to catch all events for debugging
document.addEventListener('DOMContentLoaded', function() {
  
  // Listen for all events
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (type === 'click' || type === 'submit' || type.includes('cart') || type.includes('add')) {
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
  
  // Listen for custom events
  document.addEventListener('*', function(event) {
  });
  
  // Listen for specific events that might be related to cart
  ['cart:updated', 'cart:added', 'mini-cart-open', 'cart-updated', 'cart-added'].forEach(eventType => {
    document.addEventListener(eventType, function(event) {
    });
  });
});

// Watch for Vue.js mini-cart opening and trigger our cart rendering
document.addEventListener('DOMContentLoaded', function() {
  
  // Watch for mini-cart element
  const miniCartElement = document.querySelector('mini-cart');
  if (miniCartElement) {
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const classList = miniCartElement.classList;
          if (classList.contains('mini-cart--open')) {
            
            // Fetch current cart and render with our logic
            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cartData) => {
                renderCart(cartData);
              })
              .catch((err) => console.error("Cart update failed:", err));
          }
        }
      });
    });
    
    observer.observe(miniCartElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Also watch for any element with mini-cart--open class
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('mini-cart--open')) {
            
            // Fetch current cart and render with our logic
            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cartData) => {
                renderCart(cartData);
              })
              .catch((err) => console.error("Cart update failed:", err));
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 

// Rebuy Custom code - update mini cart on click
function setupRebuyButtonHandlers() {
  document.addEventListener('rebuy:loaded', function () {
    attachRebuyButtonListeners();
  });
  
  let pollCount = 0;
  const maxPolls = 20;
  const pollInterval = setInterval(() => {
    pollCount++;
    const targetWidget = document.querySelector('[data-rebuy-id="231166"]');
    if (targetWidget) {
      clearInterval(pollInterval);
      attachRebuyButtonListeners();
    } else if (pollCount >= maxPolls) {
      clearInterval(pollInterval);
      attachRebuyButtonListenersAlternative();
    }
  }, 500);
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector) {
            const targetWidget = node.querySelector('[data-rebuy-id="231166"]') || 
                               (node.matches('[data-rebuy-id="231166"]') ? node : null);
            if (targetWidget) {
              attachRebuyButtonListeners();
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function attachRebuyButtonListeners() {
  const targetWidget = document.querySelector('[data-rebuy-id="231166"]');
  
  if (!targetWidget) {
    return;
  }
  
  setTimeout(() => {
    const buttonSelectors = [
      '.rebuy-button',
      'button.rebuy-button',
      '[data-rebuy-action="add-to-cart"]',
      'button[data-rebuy-action="add-to-cart"]',
      'button[data-rebuy-action]',
      '.rebuy-widget button',
      '.rebuy-product-block button',
      'button'
    ];
    
    let buttonsFound = 0;
    
    buttonSelectors.forEach(selector => {
      const buttons = targetWidget.querySelectorAll(selector);
      if (buttons.length > 0) {
        buttonsFound += buttons.length;
        
        buttons.forEach(button => {
          // Skip if button already has our listener
          if (button.hasAttribute('data-rebuy-handled')) {
            return;
          }
          
          const productBlock = button.closest('.rebuy-product-block');
          
          const buttonText = button.textContent.toLowerCase();
          const isAddToCartButton = buttonText.includes('add') ||
                                   buttonText.includes('cart') ||
                                   buttonText.includes('buy') ||
                                   button.getAttribute('data-rebuy-action') === 'add-to-cart' ||
                                   button.classList.contains('rebuy-button') ||
                                   button.classList.contains('add-to-cart');
          
          if (isAddToCartButton) {
            // Remove any existing listeners first
            button.removeEventListener('click', handleRebuyButtonClick, true);
            button.removeEventListener('click', handleRebuyButtonClick, false);
            
            // Add our listener
            button.addEventListener('click', handleRebuyButtonClick, true);
            
            // Mark as handled to prevent duplicates
            button.setAttribute('data-rebuy-handled', 'true');
          }
        });
      }
    });
    
    if (buttonsFound === 0) {
      attachRebuyButtonListenersAlternative();
    }
  }, 1000);
}

function attachRebuyButtonListenersAlternative() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button');
    if (!button) return;
    
    const rebuyWidget = button.closest('[data-rebuy-id="231166"]');
    if (!rebuyWidget) return;
    
    const buttonText = button.textContent.toLowerCase();
    const isAddToCartButton = buttonText.includes('add') ||
                             buttonText.includes('cart') ||
                             buttonText.includes('buy') ||
                             button.getAttribute('data-rebuy-action') === 'add-to-cart' ||
                             button.classList.contains('rebuy-button') ||
                             button.classList.contains('add-to-cart');
    
    if (isAddToCartButton) {
      handleRebuyButtonClick(e);
    }
  }, true);
}

function handleRebuyButtonClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const button = e.target;
  
  // Prevent duplicate clicks while processing
  if (button.hasAttribute('data-processing')) {
    return;
  }
  
  // Mark as processing
  button.setAttribute('data-processing', 'true');
  
  const productBlock = button.closest('.rebuy-product-block');
  let productId = null;
  let variantId = null;
  
  if (productBlock) {
    productId = productBlock.getAttribute('data-rebuy-product-id') || 
                productBlock.querySelector('[data-rebuy-product-id]')?.getAttribute('data-rebuy-product-id');
    
    variantId = productBlock.getAttribute('data-rebuy-variant-id') ||
                button.getAttribute('data-rebuy-variant-id') ||
                productBlock.querySelector('[data-rebuy-variant-id]')?.getAttribute('data-rebuy-variant-id');
    
    if (!variantId) {
      const productLink = productBlock.querySelector('a[href*="variant="]');
      if (productLink) {
        const url = new URL(productLink.href);
        const variantParam = url.searchParams.get('variant');
        if (variantParam) {
          variantId = variantParam;
        }
      }
    }
    
    if (!variantId) {
      const productClass = productBlock.className;
      const variantMatch = productClass.match(/variant-(\d+)/);
      if (variantMatch) {
        variantId = variantMatch[1];
      }
    }
    
    if (!variantId) {
      const allElements = productBlock.querySelectorAll('[data-*]');
      for (const element of allElements) {
        const attributes = element.attributes;
        for (const attr of attributes) {
          if (attr.name.includes('variant') && attr.value) {
            variantId = attr.value;
            break;
          }
        }
        if (variantId) break;
      }
    }
  }
  
  if (variantId) {
    addProductToCart(variantId, button);
  } else {
    openMiniCart();
  }
  
  const cartChangeHandler = function() {
    document.removeEventListener('rebuy:cart.change', cartChangeHandler);
    ensureMiniCartOpen();
  };
  
  document.addEventListener('rebuy:cart.change', cartChangeHandler);
  
  const alternativeEvents = ['cart:updated', 'cart:added', 'cart-updated', 'cart-added'];
  alternativeEvents.forEach(eventType => {
    const alternativeHandler = function() {
      document.removeEventListener(eventType, alternativeHandler);
      ensureMiniCartOpen();
    };
    document.addEventListener(eventType, alternativeHandler);
  });
  
  try {
    const originalClick = button.onclick;
    if (originalClick) {
      originalClick.call(button, e);
    }
  } catch (error) {
  }
}

async function addProductToCart(variantId, button) {
  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;
  
  try {
    // Quick check to see if this variant is already being added
    if (window.addingVariants && window.addingVariants.includes(variantId)) {
      console.log('Variant already being added:', variantId);
      return;
    }
    
    // Track this variant as being added
    if (!window.addingVariants) window.addingVariants = [];
    window.addingVariants.push(variantId);
    
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cartData = await response.json();
    
    await renderCart(cartData);
    
    openMiniCart();
    
    document.dispatchEvent(new Event('cart:updated'));
    
  } catch (error) {
    button.textContent = 'Error - Try Again';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
    
    openMiniCart();
  } finally {
    button.textContent = originalText;
    button.disabled = false;
    // Remove processing flag to allow future clicks
    button.removeAttribute('data-processing');
    // Remove variant from tracking
    if (window.addingVariants) {
      const index = window.addingVariants.indexOf(variantId);
      if (index > -1) {
        window.addingVariants.splice(index, 1);
      }
    }
  }
}

function ensureMiniCartOpen() {
  if (!document.documentElement.classList.contains('mini-cart--show')) {
    openMiniCart();
  }
}

setupRebuyButtonHandlers();

// Rebuy Widget: Add to bag button append in media
document.addEventListener('DOMContentLoaded', function() {
  function checkAndMoveActions() {
    const widgetContainer = document.querySelector('[data-rebuy-id="231166"]');
    
    if (widgetContainer) {
      const productBlocks = widgetContainer.querySelectorAll('.rebuy-product-block');
      
      if (productBlocks.length > 0) {
        productBlocks.forEach(function(block, index) {
          const productMedia = block.querySelector('.rebuy-product-media');
          const productActions = block.querySelector('.rebuy-product-actions');

          if (productMedia && productActions) {
            productMedia.appendChild(productActions);
          }
        });
        
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  
  let attempts = 0;
  const maxAttempts = 20;
  const checkInterval = setInterval(() => {
    attempts++;
    
    if (checkAndMoveActions() || attempts >= maxAttempts) {
      clearInterval(checkInterval);
    }
  }, 500);
});